import Heading, { HeadingProps } from '@lyra/core/components/Heading'
import React, { useEffect, useRef, useState } from 'react'
import CountUp from 'react-countup'

type Props = {
  value: number
  isDollarFormat?: boolean
  showColorChange?: boolean
  decimals?: number
} & HeadingProps

export default function HeadingNumberAnimated({
  value,
  color: colorInput,
  isDollarFormat,
  showColorChange,
  decimals = 2,
  ...headingProps
}: Props) {
  const [val, setVal] = useState(0)
  const prevVal = useRef(val)
  const [isAnimating, setIsAnimating] = useState(false)
  useEffect(() => {
    prevVal.current = value
    setVal(value)
  }, [value])

  const valChangeColor = isAnimating
    ? val > prevVal.current
      ? 'green'
      : val < prevVal.current
      ? 'red'
      : colorInput
    : colorInput

  return (
    <CountUp
      prefix={isDollarFormat ? '$' : ''}
      delay={0}
      start={prevVal.current}
      end={val}
      duration={0.5}
      decimals={decimals}
      onStart={() => setIsAnimating(true)}
      onEnd={() => setIsAnimating(false)}
    >
      {({ countUpRef }) => (
        <Heading
          {...headingProps}
          color={showColorChange ? valChangeColor : colorInput}
          ref={countUpRef}
        />
      )}
    </CountUp>
  )
}
